import React from "react";
import { EvtHeader } from "components/header";
import { useParams } from "react-router-dom";
import ActiveIntegration from "./components/active-integration";
import GithubIntegration from "./components/github";
import DiscordIntegration from "./components/discord";
import DriveIntegration from "./components/drive";
import { PermissionGate } from "permissions/components/gate";
import { useProject } from "../context";

export function ProjectIntegrations() {
  const { project_slug } = useParams();
  const { id } = useProject();

  return (
    <div className="flex-1">
      <div className="py-2">
        <EvtHeader title="Integrations" />
      </div>
      <PermissionGate rule="create:PC,JC" collection="projects__integrations">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 px-4 gap-4 md:px-6 py-6">
          <GithubIntegration project_slug={project_slug} />
          <DiscordIntegration project_slug={project_slug} />
          <DriveIntegration project_slug={project_slug} />
        </div>
      </PermissionGate>
      <ActiveIntegration project_slug={project_slug} id={id} />
    </div>
  );
}
